import { render, staticRenderFns } from "./OrderPaymentPending.vue?vue&type=template&id=335bef1a&lang=html"
import script from "./OrderPaymentPending.vue?vue&type=script&lang=js"
export * from "./OrderPaymentPending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports